import React, { useState } from 'react';
import { TrendingUp, Rocket, Heart } from 'lucide-react';
import './Hero.css';
import OrganizationSetup from './OrganizationSetup';
import CultureAssessment from './CultureAssessment';

const Hero = () => {
  const [showAssessment, setShowAssessment] = useState(false);
  const [organizationData, setOrganizationData] = useState(null);
  const [showOrganizationSetup, setShowOrganizationSetup] = useState(false);

  const handleStartAssessment = () => {
    // Reset everything to start fresh
    setShowAssessment(false);
    setShowOrganizationSetup(true);
    setOrganizationData(null);
  };

  const handleOrganizationComplete = (data) => {
    setOrganizationData(data);
    setShowOrganizationSetup(false);
    setShowAssessment(true);
  };

  const handleBackToHome = () => {
    setShowAssessment(false);
    setShowOrganizationSetup(false);
    setOrganizationData(null);
  };

  return (
    <section id="home" className="hero">
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">
              Unlock insights for a <span className="highlight">thriving workplace</span>
            </h1>
            <div className="hero-features">
              <p className="feature-item">✓ Identify hidden strengths that drive team success</p>
              <p className="feature-item">✓ Pinpoint blind spots hindering growth and performance</p>
              <p className="feature-item">✓ Gain actionable insights to boost employee satisfaction</p>
              <p className="feature-item">✓ Foster a positive environment that attracts and retains top talent</p>
            </div>
            <p className="hero-subtitle">
              Map your organization's cultural strengths and blind spots in under 3 minutes
            </p>
            <div className="hero-buttons">
              <button onClick={handleStartAssessment} className="btn btn-primary">
                Start Assessment
              </button>
              <a 
                href="https://www.enculture.ai/" 
                className="btn btn-secondary"
                target="_blank"
                rel="noopener noreferrer"
              >
                Learn More
              </a>
            </div>

          
          </div>
          <div className="hero-visual">
            <div className="hero-card card-purple">
              <div className="card-icon" style={{ background: 'linear-gradient(135deg, #9C4DF4 0%, #7C3AED 100%)' }}>
                <TrendingUp size={28} strokeWidth={2.5} />
              </div>
              <div className="hero-card-content">
                <h3>Culture Transformation</h3>
                <p>Build a culture that attracts and retains top talent</p>
              </div>
            </div>
            <div className="hero-card card-teal">
              <div className="card-icon" style={{ background: 'linear-gradient(135deg, #10B981 0%, #059669 100%)' }}>
                <Rocket size={28} strokeWidth={2.5} />
              </div>
              <div className="hero-card-content">
                <h3>Innovation Drive</h3>
                <p>Foster creativity and innovation at every level</p>
              </div>
            </div>
            <div className="hero-card card-gradient">
              <div className="card-icon" style={{ background: 'linear-gradient(135deg, #9C4DF4 0%, #3B82F6 100%)' }}>
                <Heart size={28} strokeWidth={2.5} />
              </div>
              <div className="hero-card-content">
                <h3>Employee Engagement</h3>
                <p>Create an environment where people thrive</p>
              </div>
            </div>
          </div>
        </div>
        
        {/* Organization Setup */}
        {showOrganizationSetup && (
          <div className="assessment-section">
            <div className="assessment-header">
              <button 
                type="button" 
                onClick={handleBackToHome} 
                className="close-btn" 
                aria-label="Close assessment form"
              >
                ×
              </button>
            </div>
            <div className="assessment-content">
              <OrganizationSetup onComplete={handleOrganizationComplete} />
            </div>
          </div>
        )}

        {/* Culture Health Check */}
        {showAssessment && (
          <div className="assessment-section">
            <div className="assessment-header">
              <button 
                type="button" 
                onClick={handleBackToHome} 
                className="close-btn" 
                aria-label="Close assessment results"
              >
                ×
              </button>
            </div>
            <div className="assessment-content">
              <CultureAssessment organizationData={organizationData} />
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Hero;
